import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { admin_active_component } from "../../Utils/adminFunctions";

let AdminNavigation = () => {
  //const [dashboard_nav, setDashboard_nav] = useState("");
  const [manufacturer_nav, setManufacturer_nav] = useState("");
  const [devices_nav, setDevices_nav] = useState("");
  const [participant_groups_nav, setParticipant_groups_nav] = useState("");
  const [survey_nav, setSurvey_nav] = useState("");
  const [surveyanalysisreport_nav, setSurveyanalysisreport_nav] = useState("");
  const [manageadministrateruser_nav, setManageadministrateruser_nav] =
    useState("");
  const [manageimportparticipants_nav, setManageimportparticipants_nav] =
    useState("");
  const [importdata_nav, setImportdata_nav] = useState("");
  const [managedraft_nav, setManagedraft_nav] = useState("");
  const [managereport_nav, setManagereport_nav] = useState("");

  useEffect(() => {
    let values = admin_active_component();
    //setDashboard_nav(values.dashboard_nav);
    setManufacturer_nav(values.manufacturer_nav);
    setDevices_nav(values.devices_nav);
    setParticipant_groups_nav(values.participant_groups_nav);
    setSurvey_nav(values.survey_nav);
    setSurveyanalysisreport_nav(values.surveyanalysisreport_nav);
    setManageadministrateruser_nav(values.manageadministrateruser_nav);
    setManageimportparticipants_nav(values.manageimportparticipants_nav);
    setImportdata_nav(values.importdata_nav);
    setManagedraft_nav(values.managedraft_nav);
    setManagereport_nav(values.managereport_nav);
  }, []);

  return (
    <div>
      <aside className="main-sidebar sidebar-light-primary elevation-4">
        <div style={{}}>
          <center>
            <img
              src={require("../../Assets/Images/fpmcf_logo.png")}
              alt="N/A"
              style={{ width:'11.5rem', height:'4rem', objectFit:'contain'}}
            />
          </center>
        </div>
        <div className="" style={{ height: 'full', marginTop:'-3rem'}}>
          <nav className="sidebar">
            <ul
              className="nav nav-pills nav-sidebar flex-column nav-flat"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/*
              <li className="nav-item">
                <Link
                  to="/AdminDashboard"
                  className={"nav-link nav-link" + dashboard_nav}
                >
                  <i className="fa fa-dashboard  nav-icon" />
                  <p>&nbsp; Dashboard</p>
                </Link>
              </li>
  */}

              {localStorage.getItem("user_type") == 4 && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/AdminListManufacturer"
                      className={"nav-link nav-link" + manufacturer_nav}
                    >
                      <i className="fa fa-list  nav-icon" />
                      <p>&nbsp; Manufacturers</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/AdminListDevices"
                      className={"nav-link nav-link" + devices_nav}
                    >
                      <i className="fa fa-object-ungroup  nav-icon" />
                      <p>&nbsp; Product/Devices</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/AdminListParticipantGroups"
                      className={"nav-link nav-link" + participant_groups_nav}
                    >
                      <i className="fa fa-users  nav-icon" />
                      <p>&nbsp; Participant Groups</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/survey"
                      className={"nav-link nav-link" + survey_nav}
                    >
                      <i className="fa fa-list  nav-icon" />
                      <p>&nbsp; Surveys</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/AdminListSurveyAnalysisReport"
                      className={"nav-link nav-link" + surveyanalysisreport_nav}
                    >
                      <i className="fa fa-bar-chart  nav-icon" />
                      <p>&nbsp; Survey Analysis Reports</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/admin/import-participants"
                      className={
                        "nav-link nav-link" + manageimportparticipants_nav
                      }
                    >
                      <i className="fa fa-user-md nav-icon" />
                      <p>&nbsp; Import Participants</p>
                    </Link>
                  </li>
                </>
              )}
              {localStorage.getItem("user_type") == 5 && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/manage-participants"
                      className={
                        "nav-link nav-link" + manageimportparticipants_nav
                      }
                    >
                      <i className="fa fa-user-md nav-icon" />
                      <p>&nbsp; Manage Participants</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/survey-draft-approval"
                      className={"nav-link nav-link" + managedraft_nav}
                    >
                      <i className="fa fa-inbox nav-icon" />
                      <p>&nbsp; Survey Draft Approval</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/survey-analysis-report-approval"
                      className={"nav-link nav-link" + managereport_nav}
                    >
                      <i className="fa fa-bar-chart  nav-icon" />
                      <p>&nbsp; Survey Report Approval</p>
                    </Link>
                  </li>
                </>
              )}

              {localStorage.getItem("user_type") == 1 && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/ManageAdministratorUser"
                      className={
                        "nav-link nav-link" + manageadministrateruser_nav
                      }
                    >
                      <i className="fa fa-users  nav-icon" />
                      <p>&nbsp; Manage Users</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/imports"
                      className={"nav-link nav-link" + importdata_nav}
                    >
                      <i className="fa fa-download  nav-icon" />
                      <p>&nbsp; Import Data</p>
                    </Link>
                  </li>
                  
                 
                </>
              )}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default AdminNavigation;
